var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25159 14.0316L8.76712 15.4714L16.9252 7.73145L16.9252 27.3059H19.0748L19.0748 7.73145L27.2329 15.4714L28.7484 14.0316L18 3.82065L7.25159 14.0316Z",
    fill: "#214ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7484 26.2848V30.3692H7.25159V26.2848H5.10191V30.3692C5.10191 30.9108 5.32839 31.4302 5.73154 31.8132C6.13468 32.1962 6.68146 32.4114 7.25159 32.4114H28.7484C29.3185 32.4114 29.8653 32.1962 30.2685 31.8132C30.6716 31.4302 30.8981 30.9108 30.8981 30.3692V26.2848H28.7484Z",
    fill: "#214ba5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38775 14.0316L18 3L29.6122 14.0316L27.2332 16.2917L19.6768 9.12263L19.6768 27.8945H16.3232L16.3232 9.12263L8.76684 16.2917L6.38775 14.0316ZM16.9252 7.73145L16.9252 27.3059H19.0748L19.0748 7.73145L27.2329 15.4714L28.7484 14.0316L18 3.82065L7.25159 14.0316L8.76712 15.4714L16.9252 7.73145ZM28.1465 25.6962H31.5V30.3692C31.5 31.0725 31.2057 31.7435 30.6879 32.2354C30.1706 32.7268 29.4726 33 28.7484 33H7.25159C6.52736 33 5.82941 32.7268 5.31213 32.2354C4.79427 31.7435 4.5 31.0725 4.5 30.3692V25.6962H7.8535V29.7805H28.1465V25.6962ZM28.7484 26.2848H30.8981V30.3692C30.8981 30.9108 30.6716 31.4302 30.2685 31.8132C29.8653 32.1962 29.3185 32.4114 28.7484 32.4114H7.25159C6.68146 32.4114 6.13468 32.1962 5.73154 31.8132C5.32839 31.4302 5.10191 30.9108 5.10191 30.3692V26.2848H7.25159V30.3692H28.7484V26.2848Z",
    fill: "#214ba5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.933cff04b6911d31405a513640a19b74.svg";
export { ForwardRef as ReactComponent };